module.exports = __webpack_public_path__ + "static/img/pinpai-28.8f7e7902.png";